<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />
      <v-card>
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-form @submit.prevent="download()">
            <v-card-text>
              <v-container>
                <v-row align="center" justify="center" class="text-center">
                  <v-col cols="12" md="6" lg="4">
                    <v-row class="d-flex flex-column">
                      <branch-offices-list
                        :classOfDiv="cols"
                        v-on:triggerChange="branchOfficeSelected"
                        :model="idBranchOfficeSelected"
                      />
                      <v-col>
                        <validation-provider
                          v-slot="{ errors }"
                          name="Especialidad"
                          rules="required"
                        >
                          <v-autocomplete
                            v-model="model.idSpeciality"
                            :items="specialities"
                            item-text="name"
                            item-value="idSpeciality"
                            :error-messages="errors"
                            clearable
                            dense
                            prepend-inner-icon="mdi-medical-bag"
                            no-data-text="Sin resultados disponibles"
                            label="Especialidad"
                            @change="changeSpeciality"
                            required
                          ></v-autocomplete>
                        </validation-provider>
                      </v-col>

                      <v-col v-if="false">
                        <v-expand-transition>
                          <div v-show="model.idSpeciality == 2">
                            <h3>
                              Por interpretar:
                              <span class="error--text mt-5">
                                {{ chartPending.totalPending }}
                              </span>
                              <br />
                              Interpretados: {{ chartPending.totalStudy }}
                            </h3>
                          </div>
                        </v-expand-transition>
                      </v-col>

                      <v-col>
                        <validation-provider
                          v-slot="{ errors }"
                          name="Modalidad(es)"
                        >
                          <v-autocomplete
                            v-model="model.idModalities"
                            :items="modalities"
                            item-text="name"
                            item-value="idModality"
                            :error-messages="errors"
                            auto-select-first
                            chips
                            clearable
                            deletable-chips
                            multiple
                            small-chips
                            dense
                            :disabled="!requiredModalities"
                            prepend-inner-icon="mdi-file-document"
                            label="Modalidad(es)"
                            no-data-text="Sin resultados disponibles"
                          ></v-autocomplete>
                        </validation-provider>
                      </v-col>

                      <v-col>
                        <v-btn
                          color="primary"
                          text
                          small
                          @click="listStatusBySpecialty"
                        >
                          <v-icon left>mdi-reload</v-icon>
                          Restaurar
                        </v-btn>
                        <v-btn
                          color="cyan"
                          text
                          small
                          @click="editStatus = true"
                        >
                          <v-icon left>mdi-pencil</v-icon>
                          Editar
                        </v-btn>
                      </v-col>
                      <v-col>
                        <validation-provider v-slot="{ errors }" name="Estatus">
                          <v-autocomplete
                            v-model="model.status"
                            :items="status"
                            item-text="name"
                            item-value="status"
                            :error-messages="errors"
                            auto-select-first
                            chips
                            clearable
                            deletable-chips
                            multiple
                            small-chips
                            dense
                            :disabled="!requiredStatus || !editStatus"
                            :required="requiredStatus"
                            prepend-inner-icon="mdi-filter-outline"
                            label="Estatus"
                            no-data-text="Sin resultados disponibles"
                          ></v-autocomplete>
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" md="6" lg="4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Fecha"
                      rules="required"
                    >
                      <vc-date-picker
                        color="green"
                        v-model="model.date"
                        is-required
                        required
                        :error-messages="errors"
                        :max-date="new Date()"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions class="text-center">
              <v-col>
                <v-btn
                  color="primary"
                  type="submit"
                  :disabled="invalid || sending"
                >
                  {{ sending ? "Descargando" : "Descargar" }}
                  <v-icon right>mdi-file-download-outline</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "@/components/Sidebar";
import AutoLogout from "@/components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  ReportPDFRequest,
  SpecialityRequest,
  StudyModalityRequest,
  InterpretationHistoryRequest,
  ModaltyRequest,
} from "@/core/request";
import BranchOfficesList from "../../components/BranchOfficesList.vue";

export default {
  name: "Antecedentes",
  components: {
    Loader,
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    AutoLogout,
    BranchOfficesList,
  },
  data() {
    return {
      sending: false,
      editStatus: false,
      model: {
        date: new Date(),
      },

      value: 10,
      bufferValue: 20,
      interval: 0,

      chartPending: { totalStudy: 0, totalPending: 0, value: 0 },
      specialities: [],
      modalities: [],
      profileStudies: [],
      service: ReportPDFRequest,
      search: "",
      date: null,
      encabezado: {
        icono: "mdi-pencil-circle-outline",
        texto: "Productividad",
      },
      requiredModalities: false,
      requiredStatus: false,
      status: [],
      idBranchOfficeSelected: null,
      cols: "col-md-12 col-xl-12",
    };
  },
  created() {
    this.getSpecialities();
  },
  watch: {
    "model.date": function(newVal, oldVal) {
      this.getCountPendingByBranchOffice();
    },
  },
  methods: {
    async download() {
  this.sending = true;

  let asZIP =
    this.$utilFront.nonEmptyList(this.model.idModalities) ||
    this.model.idSpeciality == 1 ||
    this.model.idSpeciality == -2 ||
    this.model.idSpeciality == 4 ||
    this.model.idSpeciality == -1 ||
    this.model.idSpeciality == 3 ||
    this.model.idSpeciality == 7 ||
    this.model.idSpeciality == 8 ||
    this.model.idSpeciality == 9 ||
    this.model.idSpeciality == 5 ||
    this.model.idSpeciality == 6;

  let asPDF = !asZIP;
  let momentDate = moment(this.model.date);
  let dateFull = momentDate.locale("es").format("LL");
  let status = [];
  if (this.$utilFront.nonEmptyList(this.model.status)) {
    status = this.model.status;
  }

  let params = {
    url: new URL(location.origin),
    asPDF: asPDF,
    idHumanResource: this.$utilFront.getIdHumanResource(),
    idBranchOffice:
      this.idBranchOfficeSelected != null
        ? this.idBranchOfficeSelected
        : this.$utilFront.getIdBranchOffice(),
    dateStart: momentDate.startOf("day"),
    dateEnd: moment(this.model.date).endOf("day"),
    dateFull: dateFull,
    speciality: this.model.idSpeciality,
    status: status,
    idModalities: this.$utilFront.nonEmptyList(this.model.idModalities)
      ? this.model.idModalities
      : [],
  };

  this.service
    .getReportProductivity(params)
    .then((res) => {
  const contentType = (res.headers?.["content-type"] || "").toLowerCase();
  const contentDisposition = (res.headers?.["content-disposition"] || "").toLowerCase();

  const isPdfHeader =
    contentType.includes("application/pdf") ||
    contentDisposition.includes(".pdf");

  const isZipHeader =
    contentType.includes("application/zip") ||
    contentDisposition.includes(".zip");

  if (isPdfHeader) {
    this.$utilFront.openPDF(res.data);
    return;
  }

  if (isZipHeader) {
    let fileName = "Reporte de productividad.zip";
    this.$utilFront.downloadZIP(res.data, fileName);
    return;
  }

  if (contentType.includes("application/json")) {
    let payload = null;

    try {
      if (res.data instanceof ArrayBuffer) {
        const text = new TextDecoder("utf-8").decode(new Uint8Array(res.data));
        payload = JSON.parse(text);
      } else if (ArrayBuffer.isView(res.data)) {
        const text = new TextDecoder("utf-8").decode(res.data);
        payload = JSON.parse(text);
      } else if (typeof res.data === "string") {
        payload = JSON.parse(res.data);
      } else {
        payload = res.data;
      }
    } catch (e) {
      payload = res.data;
    }

    const msg = payload?.data || "La descarga no se completó. Intente de nuevo.";

    if (this.$toast) this.$toast.warning(msg);
    else this.$utilFront.notifications(msg, "ERROR");

    return;
  }

  if (asPDF) {
    this.$utilFront.openPDF(res.data);
  } else {
    let fileName = "Reporte de productividad.zip";
    this.$utilFront.downloadZIP(res.data, fileName);
  }
})
    .catch((err) => {
      this.$utilFront.errorhttp(err);
    })
    .finally(() => {
      this.sending = false;
    });
},
    getSpecialities() {
      this.specialities = [];
      SpecialityRequest.allSpeciality().then((res) => {
        let { data } = res.data;
        if (this.$utilFront.nonEmptyList(data)) {
          this.specialities = data;
          this.specialities.push({ idSpeciality: -1, name: "SIGNOS VITALES" });
          this.specialities.push({ idSpeciality: -2, name: "FARMACIA" });
        }
      });
    },
    changeSpeciality() {
      this.listModaltyBySpecialty();
      this.listStatusBySpecialty();
    },
    listModaltyBySpecialty() {
      let SPECIALITY_CONSULTATION = 1;
      let SPECIALITY_DENTAL = 4;
      let SPECIALITY_PSYCHOLOGY = 7;
      let SPECIALITY_COLPOSCOPY = 8;
      let SPECIALITY_TELEMEDICINE = 9;
      let SPECIALITY_OPTOMETRY = 5;
      let SPECIALITY_AUDIOMETRY = 6;
      let SPECIALITY_IMAGE = 2;
      let SPECIALITY_LABORATORY = 3;

      this.model.idModalities = null;
      this.modalities = [];
      this.profileStudies = [];

      let idSpeciality = this.model.idSpeciality;
      this.requiredModalities =
        idSpeciality != SPECIALITY_CONSULTATION &&
        idSpeciality != SPECIALITY_PSYCHOLOGY &&
        idSpeciality != SPECIALITY_COLPOSCOPY &&
        idSpeciality != SPECIALITY_TELEMEDICINE &&
        idSpeciality != SPECIALITY_OPTOMETRY &&
        idSpeciality != SPECIALITY_AUDIOMETRY &&
        idSpeciality != SPECIALITY_DENTAL &&
        idSpeciality != SPECIALITY_LABORATORY &&
        idSpeciality >= 1;

      if (idSpeciality == SPECIALITY_IMAGE) {
        this.getCountPendingByBranchOffice();
      }

      if (this.requiredModalities) {
        let params = { speciality: { idSpeciality: this.model.idSpeciality } };
        ModaltyRequest.listModaltyBySpecialty(params).then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.modalities = res.data.data.map((modalty) => {
              return {
                name: modalty.acronym + " - " + modalty.name,
                idModality: modalty.idModality,
              };
            });
            this.requiredModalities = this.$utilFront.nonEmptyList(
              this.modalities
            );
          }
        });
      }
    },
    listStudyProfileByModality() {
      this.profileStudies = [];
      StudyModalityRequest.listStudyModalityByModalty({
        modality: this.model.idModality,
      }).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.profileStudies = res.data.data.map((profile) => {
            let acronym = "";
            if (this.$utilFront.nonEmpty(profile.acronym)) {
              acronym = profile.acronym + " - ";
            }
            return {
              text: acronym + "" + profile.name,
              value: profile.idStudyModality,
            };
          });
        }
      });
    },
    getCountPendingByBranchOffice() {
      let momentDate = moment(this.model.date);

      let params = {
        idBranchOffice: this.$utilFront.getIdBranchOffice(),
        start: momentDate.startOf("day"),
        end: moment(this.model.date).endOf("day"),
      };

      this.chartPending = { totalStudy: 0, totalPending: 0, value: 0 };

      InterpretationHistoryRequest.getCountPendingByBranchOffice(params).then(
        (res) => {
          this.chartPending = res.data.data;
        }
      );
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
    },
    listStatusBySpecialty() {
      let idSpeciality = this.model.idSpeciality;
      this.status = [];
      this.requiredStatus = false;
      if (this.$utilFront.nonEmpty(idSpeciality)) {
        SpecialityRequest.listStatusBySpecialty({ idSpeciality: idSpeciality })
          .then((res) => {
            let { data, status, code } = res.data;
            if (code == 200 && this.$utilFront.nonEmptyList(data)) {
              this.status = data;
              this.model.status = data
                .filter((it) => {
                  return it.default;
                })
                .map((it) => {
                  return it.status;
                });
              this.requiredStatus = true;
              this.editStatus = false;
            }
          })
          .catch(this.$utilFront.errorhttp)
          .finally(() => {});
      }
    },
  },
};
</script>
<style>
.container-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "Input calendar ."
    "input2 calendar ."
    ". . .";
}

.Input {
  grid-area: Input;
}

.calendar {
  grid-area: calendar;
}

.input2 {
  grid-area: input2;
}
</style>
